import About from "../../components/About/About"
import "./AboutPage.css";

export default function AboutPage() {
    return (
        <div className="About container">
            <h2 className="homepage-title">Meet The Team!</h2>
            <hr/>
            <About/>
        </div>
    )
}